import { isActionOf } from "typesafe-actions";
import { useDispatch } from "react-redux";
import type { ThunkDispatchCommon } from "single-spa/store/types";
import { createProfileThunk, updateProfileThunk } from "../../store/effects";
import { createProfileAsync } from "../../store/action-creators";
import { isSavedProfile } from "../../helpers/common";
import type { Profile } from "../../types/common";
import type { EmployeeProfileProps } from "./EmployeeProfile";
import EmployeeProfile from "./EmployeeProfile";

type EmployeeProfileContainerProps = Omit<EmployeeProfileProps, "onProfileChange" | "onRename"> & {
    onProfileChange(profile: Profile): void;
    onSaveSuccess(profile: Profile): void;
    onRenameSuccess(profile: Profile): void;
};

const EmployeeProfileContainer = (props: EmployeeProfileContainerProps) => {
    const { onProfileChange, onSaveSuccess, onRenameSuccess, ...rest } = props;
    const dispatch: ThunkDispatchCommon = useDispatch();

    async function saveProfile({ id, ...restProfile }: Profile) {
        const resultAction = await dispatch(createProfileThunk(restProfile));
        const isSuccessfulAction = isActionOf(createProfileAsync.success);

        if (isSuccessfulAction(resultAction)) {
            onSaveSuccess(resultAction.payload);
        }
    }

    function handleProfileRename(profile: Profile) {
        void dispatch(updateProfileThunk(profile));
        onRenameSuccess(profile);
    }

    function handleProfileUpdate(propertyName: keyof Omit<Profile, "isEnabled" | "isExpanded">, profile: Profile) {
        if (!isSavedProfile(profile)) {
            void saveProfile(profile);
        } else {
            void dispatch(updateProfileThunk(profile));
        }

        return onProfileChange(profile);
    }

    return (
        <EmployeeProfile
            {...rest}
            onProfileChange={handleProfileUpdate}
            onRename={handleProfileRename}
        />
    );
}

export default EmployeeProfileContainer;
